import { useEffect, useMemo, useState } from 'react';
import { getTotalPages, clampPage, sliceItems } from '../utils/paginationUtils';
// メモリ上の配列をページ単位に切り出す hook。
// サーバー分頁ページでは使わず、全量取得ページで使う。
export function usePagination(items, initialPageSize = 20) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const totalItems = items.length;
    const totalPages = getTotalPages(totalItems, pageSize);
    // フィルタ等で件数が減りページが範囲外になったら補正する。
    useEffect(() => {
        const clamped = clampPage(page, totalPages);
        if (clamped !== page)
            setPage(clamped);
    }, [page, totalPages]);
    const pageItems = useMemo(() => sliceItems(items, page, pageSize), [items, page, pageSize]);
    return { page, pageSize, totalPages, totalItems, pageItems, setPage, setPageSize };
}
export default usePagination;
